import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

const BaseInput = ({
    disabled,
    errorMessage,
    inputType,
    intl,
    isValid,
    label,
    maxLength,
    minLength,
    name,
    onBlur,
    onChange,
    onClick,
    onFocus,
    placeholder,
    required,
    value,
}) => (
    <div className="input-elem-sto">
        <label htmlFor={name}>
            <FormattedMessage id={label} />
        </label>

        <input
            autoComplete="off"
            className={`input-sto ${inputType} ${isValid === false ? 'hasError ' : 'isValid'}`}
            disabled={disabled}
            id={name}
            maxLength={maxLength}
            minLength={minLength}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            onClick={onClick}
            onFocus={onFocus}
            placeholder={intl.formatMessage({ id: placeholder })}
            required={required}
            type={inputType}
            value={value}
        />

        <p className={`input-sto-placeholder input-sto-placeholder-error ${isValid !== false ? 'hidden' : ''}`}>
            {errorMessage && <FormattedMessage id={errorMessage} />}
        </p>
    </div>
);
BaseInput.propTypes = {
    disabled: PropTypes.bool,
    errorMessage: PropTypes.string,
    inputType: PropTypes.string,
    isValid: PropTypes.bool,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
};

BaseInput.defaultProps = {
    inputType: 'text',
    isValid: null,
    required: true,
};

export default injectIntl(BaseInput);
